var _path, _g, _path2, _path3, _path4, _path5, _circle, _path6, _circle2, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g2, _path16, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSnappitAccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 716.79,
    height: 683.19,
    viewBox: "0 0 716.79 683.19",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m450.81,682c0,.66.53,1.19,1.19,1.19h263.59c.66,0,1.19-.53,1.19-1.19s-.53-1.19-1.19-1.19h-263.59c-.66,0-1.19.53-1.19,1.19Z",
    fill: "#3f3d58"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m546.64,348.65l-3.05,7.63s-2.81,10.68.48,14.94,4.02,36.87.49,39.28c-3.54,2.41,44.82-22.33,44.82-22.33,0,0-18.88-43.78-19.2-43.94s-12.69-4.02-12.69-4.02l-10.84,8.43Z",
    fill: "#2f2e43"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "578.12 386.36 561.92 391.69 561.92 368.37 576.62 368.37 578.12 386.36",
    fill: "#f6a6a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uuid-48393ca6-ae17-4485-8fd8-05ea309d195e-128",
    d: "m528.6,518.76c-.88,5.34-4.44,9.17-7.96,8.56-3.52-.62-5.66-5.45-4.78-10.79.32-2.14,1.17-4.16,2.47-5.9l4.02-22.59,10.93,2.29-5.12,22.02c.67,2.08.83,4.28.44,6.41,0,0,0,0,0,0Z",
    fill: "#f6a6a9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 556.86,
    y: 647.44,
    width: 15.18,
    height: 21.53,
    fill: "#f6a6a9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m542.08,682c-1.6,0-3.02-.04-4.09-.14-4.03-.37-7.88-3.34-9.81-5.08-.87-.78-1.15-2.03-.69-3.1h0c.32-.77.97-1.35,1.78-1.58l10.65-3.04,17.25-11.64.19.34c.07.13,1.77,3.18,2.33,5.24.22.78.16,1.44-.17,1.94-.23.35-.54.55-.8.67.31.33,1.29.99,4.3,1.47,4.4.7,5.32-3.86,5.36-4.05l.03-.15.13-.08c2.09-1.35,3.38-1.96,3.83-1.83.28.08.74.22,1.99,12.64.13.39,1,3.25.41,5.98-.65,2.97-13.63,1.95-16.23,1.71-.07,0-9.8.7-16.46.7Z",
    fill: "#2f2e43"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 606.91,
    y: 632.91,
    width: 15.18,
    height: 21.53,
    transform: "translate(-247.53 422.68) rotate(-31.95)",
    fill: "#f6a6a9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m598.14,679.05c-1.78,0-3.42-.21-4.58-.42-1.15-.2-2.04-1.11-2.23-2.26h0c-.13-.83.11-1.66.67-2.28l7.43-8.22,8.48-19,.35.19c.13.07,3.18,1.76,4.75,3.21.6.55.9,1.14.88,1.74,0,.42-.17.76-.32.99.44.11,1.62.16,4.43-1.03,4.1-1.73,2.48-6.09,2.4-6.28l-.06-.14.07-.14c1.06-2.25,1.83-3.46,2.28-3.58.28-.08.75-.2,8.38,9.67.31.26,2.57,2.22,3.51,4.86,1.02,2.87-10.54,8.87-12.86,10.04-.07.06-12.17,8.85-17.13,11.35-1.97.99-4.3,1.3-6.43,1.3Z",
    fill: "#2f2e43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m583.21,467.41h-42.48l-3.86,39.52,16.87,146.02h21.69l-8.67-84.34,35.18,76.14,19.28-13.49-27.47-71.08s9.81-61.93,2.1-77.35c-7.71-15.42-12.63-15.42-12.63-15.42Z",
    fill: "#2f2e43"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "604.34 469.82 530.6 469.82 557.11 382.59 586.51 382.59 604.34 469.82",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m561.75,382.6s-18.31-.48-20.24,4.34c-1.93,4.82-24.58,119.52-24.58,119.52h14.94l29.88-123.86Z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 563.93,
    cy: 358.68,
    r: 16.14,
    fill: "#f6a6a9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m567.06,333.6s19.44-4.98,25.38,20.88c0,0,.16,6.75,3.53,9.48,3.37,2.73,2.25,16.87,2.25,16.87,0,0,6.43,10.6.96,15.42,0,0-2.41,9.8,1.12,15.42,3.53,5.62,16.87,36.55-5.3,38.43,0,0-11.24-6.79-5.94-27.03,5.3-20.24-.64-31.42-.64-31.42,0,0-17.03-6.17-16.06-19.35.96-13.17-10.92-26.18-11.73-26.02s-9.16-4.66-12.85,10.12l-3.96-.67s-1.66-24.87,23.24-22.14Z",
    fill: "#2f2e43"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "uuid-5634515f-d760-4925-b0a8-442b9e09929d-129",
    d: "m616.92,516.16c1.08,5.31-.89,10.15-4.4,10.83-3.51.67-7.22-3.08-8.3-8.39-.46-2.11-.39-4.31.21-6.39l-4.27-22.54,11.03-1.74,3.03,22.41c1.37,1.71,2.29,3.71,2.69,5.84,0,0,0,0,0,0Z",
    fill: "#f6a6a9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m573.66,382.7s16.13-2.04,18.06,2.78c1.93,4.82,24.58,119.52,24.58,119.52h-14.94s-27.69-122.29-27.69-122.29Z",
    fill: "#e6e6e6"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m96.98,211.83H18.38c-10.13,0-18.38-8.24-18.38-18.38v-78.6c0-10.13,8.24-18.38,18.38-18.38h78.6c10.13,0,18.38,8.24,18.38,18.38v78.6c0,10.13-8.24,18.38-18.38,18.38ZM18.38,98.48c-9.03,0-16.38,7.35-16.38,16.38v78.6c0,9.03,7.35,16.38,16.38,16.38h78.6c9.03,0,16.38-7.35,16.38-16.38v-78.6c0-9.03-7.35-16.38-16.38-16.38H18.38Z",
    fill: "#ccc"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m267.66,211.83h-78.6c-10.13,0-18.38-8.24-18.38-18.38v-78.6c0-10.13,8.24-18.38,18.38-18.38h78.6c10.13,0,18.38,8.24,18.38,18.38v78.6c0,10.13-8.24,18.38-18.38,18.38Zm-78.6-113.36c-9.03,0-16.38,7.35-16.38,16.38v78.6c0,9.03,7.35,16.38,16.38,16.38h78.6c9.03,0,16.38-7.35,16.38-16.38v-78.6c0-9.03-7.35-16.38-16.38-16.38h-78.6Z",
    fill: "#ccc"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m267.66,425.9h-78.6c-10.13,0-18.38-8.24-18.38-18.38v-78.6c0-10.13,8.24-18.38,18.38-18.38h78.6c10.13,0,18.38,8.24,18.38,18.38v78.6c0,10.13-8.24,18.38-18.38,18.38Zm-78.6-113.36c-9.03,0-16.38,7.35-16.38,16.38v78.6c0,9.03,7.35,16.38,16.38,16.38h78.6c9.03,0,16.38-7.35,16.38-16.38v-78.6c0-9.03-7.35-16.38-16.38-16.38h-78.6Z",
    fill: "#ccc"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m96.98,425.9H18.38c-10.13,0-18.38-8.24-18.38-18.38v-78.6c0-10.13,8.24-18.38,18.38-18.38h78.6c10.13,0,18.38,8.24,18.38,18.38v78.6c0,10.13-8.24,18.38-18.38,18.38Zm-78.6-113.36c-9.03,0-16.38,7.35-16.38,16.38v78.6c0,9.03,7.35,16.38,16.38,16.38h78.6c9.03,0,16.38-7.35,16.38-16.38v-78.6c0-9.03-7.35-16.38-16.38-16.38H18.38Z",
    fill: "#ccc"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 111.03,
    cy: 315.66,
    r: 23.31,
    fill: "#6c63ff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m438.34,211.83h-78.6c-10.13,0-18.38-8.24-18.38-18.38v-78.6c0-10.13,8.24-18.38,18.38-18.38h78.6c10.13,0,18.38,8.24,18.38,18.38v78.6c0,10.13-8.24,18.38-18.38,18.38Zm-78.6-113.36c-9.03,0-16.38,7.35-16.38,16.38v78.6c0,9.03,7.35,16.38,16.38,16.38h78.6c9.03,0,16.38-7.35,16.38-16.38v-78.6c0-9.03-7.35-16.38-16.38-16.38h-78.6Z",
    fill: "#ccc"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 455.72,
    cy: 101.6,
    r: 23.31,
    fill: "#6c63ff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m78.21,235.83H31.32c-3.67,0-6.65-2.98-6.65-6.65s2.98-6.65,6.65-6.65h46.89c3.67,0,6.65,2.98,6.65,6.65s-2.98,6.65-6.65,6.65Z",
    fill: "#e6e6e6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m251.8,235.83h-46.89c-3.67,0-6.65-2.98-6.65-6.65s2.98-6.65,6.65-6.65h46.89c3.67,0,6.65,2.98,6.65,6.65s-2.98,6.65-6.65,6.65Z",
    fill: "#e6e6e6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m425.4,235.83h-46.89c-3.67,0-6.65-2.98-6.65-6.65s2.98-6.65,6.65-6.65h46.89c3.67,0,6.65,2.98,6.65,6.65s-2.98,6.65-6.65,6.65Z",
    fill: "#e6e6e6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m438.34,427.9h-78.6c-10.13,0-18.38-8.24-18.38-18.38v-78.6c0-10.13,8.24-18.38,18.38-18.38h78.6c10.13,0,18.38,8.24,18.38,18.38v78.6c0,10.13-8.24,18.38-18.38,18.38Zm-78.6-113.36c-9.03,0-16.38,7.35-16.38,16.38v78.6c0,9.03,7.35,16.38,16.38,16.38h78.6c9.03,0,16.38-7.35,16.38-16.38v-78.6c0-9.03-7.35-16.38-16.38-16.38h-78.6Z",
    fill: "#ccc"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m425.4,451.89h-46.89c-3.67,0-6.65-2.98-6.65-6.65s2.98-6.65,6.65-6.65h46.89c3.67,0,6.65,2.98,6.65,6.65s-2.98,6.65-6.65,6.65Z",
    fill: "#e6e6e6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m609.03,211.83h-78.6c-10.13,0-18.38-8.24-18.38-18.38v-78.6c0-10.13,8.24-18.38,18.38-18.38h78.6c10.13,0,18.38,8.24,18.38,18.38v78.6c0,10.13-8.24,18.38-18.38,18.38Zm-78.6-113.36c-9.03,0-16.38,7.35-16.38,16.38v78.6c0,9.03,7.35,16.38,16.38,16.38h78.6c9.03,0,16.38-7.35,16.38-16.38v-78.6c0-9.03-7.35-16.38-16.38-16.38h-78.6Z",
    fill: "#ccc"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m596.08,235.83h-46.89c-3.67,0-6.65-2.98-6.65-6.65s2.98-6.65,6.65-6.65h46.89c3.67,0,6.65,2.98,6.65,6.65s-2.98,6.65-6.65,6.65Z",
    fill: "#e6e6e6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m78.21,449.89H31.32c-3.67,0-6.65-2.98-6.65-6.65s2.98-6.65,6.65-6.65h46.89c3.67,0,6.65,2.98,6.65,6.65s-2.98,6.65-6.65,6.65Z",
    fill: "#e6e6e6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m251.8,449.89h-46.89c-3.67,0-6.65-2.98-6.65-6.65s2.98-6.65,6.65-6.65h46.89c3.67,0,6.65,2.98,6.65,6.65s-2.98,6.65-6.65,6.65Z",
    fill: "#e6e6e6"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 297.74,
    cy: 513.92,
    r: 5.72,
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 314.7,
    cy: 513.92,
    r: 5.72,
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.66,
    cy: 513.92,
    r: 5.72,
    fill: "#e6e6e6"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m393.26,28.19h-157.14c-7.77,0-14.09-6.32-14.09-14.09s6.32-14.09,14.09-14.09h157.14c7.77,0,14.09,6.32,14.09,14.09s-6.32,14.09-14.09,14.09ZM236.13,2c-6.67,0-12.09,5.43-12.09,12.09s5.43,12.09,12.09,12.09h157.14c6.67,0,12.09-5.43,12.09-12.09s-5.43-12.09-12.09-12.09h-157.14Z",
    fill: "#ccc"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m281.11,17.78c-3.16,0-5.73-2.57-5.73-5.73s2.57-5.73,5.73-5.73,5.73,2.57,5.73,5.73-2.57,5.73-5.73,5.73Zm0-9.9c-2.3,0-4.17,1.87-4.17,4.17s1.87,4.17,4.17,4.17,4.17-1.87,4.17-4.17-1.87-4.17-4.17-4.17Z",
    fill: "#484662"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m291.91,22.47c-.18,0-.36-.06-.51-.19l-7.24-6.21c-.33-.28-.36-.77-.08-1.1.28-.33.77-.36,1.1-.08l7.24,6.21c.33.28.36.77.08,1.1-.15.18-.37.27-.59.27Z",
    fill: "#484662"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnappitAccess);
export default __webpack_public_path__ + "static/media/snappit-access.5f913d05d124ff7554d2f847d54d9670.svg";
export { ForwardRef as ReactComponent };